module.exports = __webpack_public_path__ + "img/Emoticon-Bad.5a6de3ce.svg";